/**
 * Parses worker name to ensure both firstName and lastName are available.
 * Required for contractor badge generation which needs both names to calculate
 * font size and properly format the display name on the badge.
 *
 * @param worker - Worker object with name fields
 * @returns Object with firstName and lastName properties
 */
export function parseWorkerName(worker: { name: string; firstName?: string; lastName?: string }): {
  firstName: string;
  lastName: string;
} {
  if (worker.firstName?.trim() && worker.lastName?.trim()) {
    return {
      firstName: worker.firstName,
      lastName: worker.lastName,
    };
  }

  const splitName = worker.name.split(" ");
  return {
    firstName: splitName[0],
    lastName: splitName.slice(1).join(" "),
  };
}
